import * as React from "react";

import { WizardRegionHotwireContentProps } from "../typings";
import { MobileContentWithImage } from "./MobileContentWithImage";
import { MobileContentNoImage } from "./MobileContentNoImage";

export const MobileContent = ({ lineOfBusiness, model, destinationHero, wizard }: WizardRegionHotwireContentProps) => {
  const hasBackgroundImage = !!(model.smallBackgroundImage || destinationHero);

  return (
    <div
      className="WizardRegionHotwire"
      data-testid="wizard-region-hotwire"
      data-module={`farefinder-${lineOfBusiness}`}
    >
      {hasBackgroundImage ? (
        <MobileContentWithImage model={model} destinationHero={destinationHero} wizard={wizard} />
      ) : (
        <MobileContentNoImage model={model} wizard={wizard} />
      )}
    </div>
  );
};
